import React, { useContext, useState, useEffect } from "react";
import { store } from "../store";
import { Row, Col } from 'antd';
import { Text, View, FlatList, Pressable, ScrollView, TextInput, Image, Dimensions, Modal } from 'react-native-web';
import { themeColor, default_shop } from "../config/servervar";
import { ViewList, ViewDetail } from '../component/listdetail';
import { CustomIcon } from "../component/custom";
import EventEmitter from "../component/EventEmitter";
import { useDebounce } from "../component/custom";
import axios from 'axios'
import { server_var } from "../config/servervar";

const LIST_DEFINE = [
  { id: 1, field1: 'id', flex: 0.1, textAlign: 'left', headerTitle: 'ID' },
  { id: 2, field1: 'mobileNumber', flex: 0.2, textAlign: 'left', headerTitle: 'UserName' },
  { id: 3, field1: 'displayName', flex: 0.4, textAlign: 'left', headerTitle: 'ผู้ใช้งาน' },
  { id: 4, field1: 'roles', flex: 0.1, textAlign: 'left', headerTitle: 'role' },
  { id: 5, field1: 'memberStatus', flex: 0.1, textAlign: 'left', headerTitle: 'Status' },
];

const DETAIL_DEFINE = [
  {
    id: 1, fieldName: 'id', displayName: 'ID', newValue: 0, controlOption: {
      textInputStyle: { backgroundColor: 'lightgray' }, textInputProp: { editable: false }
    }
  },
  { id: 2, fieldName: 'avatar', displayName: 'รูป', newValue: '', controlType: 'photoupload', controlOption: { width: 80, height: 80 } },
  { id: 4, fieldName: 'mobileNumber', displayName: 'UserName', newValue: '' },
  { id: 5, fieldName: 'firstName', displayName: 'ชื่อ', newValue: '' },
  { id: 6, fieldName: 'lastName', displayName: 'นามสกุล', newValue: '' },
  { id: 7, fieldName: 'password', displayName: 'รหัสผ่าน', newValue: '', controlType: 'password' },
  {
    id: 8, fieldName: 'roles', displayName: 'role', newValue: '', controlType: 'dropdown', controlOption: {
      list: [{ id: 1, title: '', value: '' }, { id: 2, title: 'admin', value: 'admin' }, { id: 3, title: 'pharmacist', value: 'pharmacist' }]
    }
  },
  {
    id: 9, fieldName: 'gender', displayName: 'เพศ', newValue: 'F', controlType: 'radio',
    controlOption: {
      list: [
        { id: 1, title: 'หญิง', value: 'F' },
        { id: 2, title: 'ชาย', value: 'M' },
      ]
    }
  },
  { id: 10, fieldName: 'staffId', displayName: 'Staff Id', newValue: '' },
  { id: 11, fieldName: 'staffCerNo', displayName: 'หมายเลขเภสัชกร', newValue: '' },
  {
    id: 12, fieldName: 'memberStatus', displayName: 'สถานะ', newValue: 'verified', controlType: 'dropdown', controlOption: {
      list: [
        { id: 1, title: 'verified', value: 'verified' }, { id: 2, title: 'inactive', value: 'inactive' }
      ]
    }
  },
  {
    id: 15, fieldName: 'memberlist', displayName: 'สมาชิก', newValue: [], controlType: 'component', component: (props) => <ShopCom {...props} />
  },
];

const QUERY_NAME = 'users';
const QUERY_CON = { staffFlag: 1 };
const NEW_VALUE = { staffFlag: 1 };
const QUERY_DETAIL_CON = { "$include_shop$": 1 };

export const User = () => {
  const [selectIndex, setSelectIndex] = useState(-1);
  const { globalState } = useContext(store);

  const beforeSavePress = async (data) => {
    return { data, errorList: validateData(data) }
  }

  const [queryParams, setQueryParams] = useState();

  const validateData = (data) => {
    let tmpErrorList = [];
    for (const item of ['mobileNumber', 'roles', 'firstName', 'lastName']) {
      if (!(data?.[item])) {
        tmpErrorList = [...tmpErrorList, { fieldName: item, errorFlag: true, errorMsg: 'ไม่สามารถเว้นไว้ได้' }]
      }
    }
    console.log('point1', data?.['password'] != undefined);
    console.log('point2', !(data?.['password']));
    if (data?.['password'] != undefined && !(data?.['password'])) {
      console.log('point3');
      tmpErrorList = [...tmpErrorList, { fieldName: 'password', errorFlag: true, errorMsg: 'ไม่สามารถเว้นไว้ได้' }]
    }
    return tmpErrorList
  }

  const downloadTxtFile = async () => {
    const res = await axios.post(`${server_var.server_api}/extractStaff`, queryParams)
    if (res?.data?.csv) {
      console.log('texts', res.data.csv);
      const file = new Blob([res.data.csv], { type: 'text/plain' });
      const element = document.createElement("a");
      element.href = URL.createObjectURL(file);
      element.download = "staff" + Date.now() + ".csv";
      document.body.appendChild(element);
      element.click();
    } else if (res.data.message) {
      alert(res.data.message);
    } else {
      alert('มีข้อผิดพลาดเกิดขึ้น')
    }
  }

  const onChangeQuery = (queryParams) => {
    setQueryParams(queryParams);
  }

  return (
    <Row style={{ flex: 1, flexWrap: 'nowrap' }}>
      <Col span={12} style={{ height: '100vh', padding: 5 }}>
        <ViewList
          onPress={id => setSelectIndex(id)} listDefine={LIST_DEFINE} queryName={QUERY_NAME} queryCon={QUERY_CON}
          onChangeQuery={onChangeQuery}
          viewListOption={{
            topControlList: [
              { id: 2, title: 'Search', type: 'multi_column_search', searchField: ['displayName'], placeholder: 'ค้นหาตามชื่อ', textInputStyle: { width: 200 } },
              { id: 3, title: 'Search2', type: 'simple_search', searchField: '$find_shop$', placeholder: 'ค้นหาตามชื่อร้าน/รหัสร้าน', textInputStyle: { width: 200 } },
              {
                id: 4, title: '', type: 'dropdown', searchField: 'memberStatus', list: [
                  { id: 1, title: 'verified', value: 'verified' },
                  { id: 2, title: 'inactive', value: 'inactive' },
                ]
              },
              { id: 5, title: 'Export', type: 'button', onPress: () => downloadTxtFile() },
            ]
          }}

        />
      </Col>
      <Col span={12} style={{
        height: '100vh', padding: 5,
        borderWidth: 1, borderLeftStyle: 'solid', borderColor: 'gray'
      }}>
        <ViewDetail
          selectIndex={selectIndex} detailDefine={DETAIL_DEFINE} queryName={QUERY_NAME} newValue={NEW_VALUE}
          onSavePress={(id) => {
            console.log('observe1', id);
            EventEmitter.notify('ShopCom::save', { userId: id });
            setSelectIndex(-1)
          }}
          onDeletePress={async (id) => {
            await globalState.client.service('shopusers').remove(null, { query: { userId: id } });
          }}
          viewDetailOption={{ hideDelete: false }}
          beforeSavePress={beforeSavePress}
          queryCon={QUERY_DETAIL_CON}
        />
      </Col>
    </Row>
  )
}

function ShopCom({ data }) {
  const { globalState } = useContext(store);
  const [shopList, setShopList] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const dataJson = data.reduce((acc, item3) => ({ ...acc, [item3[0]]: item3[1] }), {});

  useEffect(() => {
    if (dataJson?.id > 0) {
      loadData();
      return;
    }
    if (dataJson?.id == 0) {
      setShopList([])
    }
  }, [dataJson?.id]);

  useEffect(() => {
    EventEmitter.addListener('ShopCom::save', saveShopCom);
    EventEmitter.addListener('ShopCom::add', addShopCom);
    return () => {
      EventEmitter.removeListener('ShopCom::save', saveShopCom);
      EventEmitter.removeListener('ShopCom::add', addShopCom);
    };
  }, [dataJson?.id, shopList])

  const saveShopCom = async (payload) => {
    console.log('shopList!!', shopList);
    // alert("save shoplist" + JSON.stringify(shopList));

    await globalState.client.service('shopusers').remove(null, { query: { userId: dataJson?.id } });
    await globalState.client.service('shopusers').create(
      // shopList.map(item3 => ({ userId: item3.userId, shopId: item3.shopId, statusOnline: 'offline' }))
      shopList.map(item3 => ({ userId: payload.userId, shopId: item3.shopId, statusOnline: 'offline' }))
    );
  }

  const addShopCom = (payload) => {
    if (shopList?.filter(item4 => item4.shopId == payload.shopId).length == 0) {
      setShopList(prev => ([...prev, { ...payload, userId: dataJson?.id }]))
    }
  }

  const loadData = async () => {
    console.log('load1');
    const res = await globalState.client.service('shopusers').find({ query: { userId: dataJson?.id } })
    setShopList(res.data)
    console.log('load2', res.data);
  }

  return (
    <View>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
        {/* <Text>{JSON.stringify(shopList)}</Text> */}
        {shopList?.map(item6 => (
          <View key={item6.id.toString()} style={{ alignItems: 'center' }}>
            <Image
              source={{ uri: item6?.shop?.shopPhoto1 ?? default_shop }}
              style={{ width: 60, height: 60, borderRadius: 30, marginRight: 20, marginLeft: 20, borderWidth: 1, borderColor: themeColor.color102 }}
            />
            <Text style={{ marginTop: 5 }}>{item6?.shop?.shopThName}</Text>
            <Pressable style={{ position: 'absolute', top: 0, right: 0 }}
              onPress={() => setShopList(prev => {
                const tmp1 = [...prev].filter(item7 => item7.id != item6.id);
                return tmp1;
              })}
            >
              <CustomIcon name="close-circle" size={20} color={'red'} />
            </Pressable>
          </View>
        ))}
        <Pressable
          onPress={() => setShowDialog(true)}
          style={{ marginHorizontal: 10 }}
        >
          <View style={{ width: 60, height: 60, justifyContent: 'center', alignItems: 'center' }}>
            <CustomIcon name="plus-circle" size={40} color={themeColor.color1} />
          </View>
        </Pressable>
        <Dialog showDialog={showDialog} setShowDialog={setShowDialog}>
          <DialogAddShop />
        </Dialog>
      </View>
    </View>
  )
}

function Dialog({ showDialog, setShowDialog, children }) {
  return (
    <Modal visible={showDialog} transparent={true}>
      <View style={{
        position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        justifyContent: 'center', alignItems: 'center'
      }}>
        <View style={{
          backgroundColor: 'white',
          paddingHorizontal: 20, paddingVertical: 20, borderRadius: 10
        }}>
          <Pressable style={{ position: 'absolute', top: 0, right: 0 }} onPress={() => setShowDialog(false)}>
            <CustomIcon name="close-circle" size={30} color="gray" />
          </Pressable>
          {children}
        </View>
      </View>
    </Modal>
  )
}

function DialogAddShop() {
  const { globalState } = useContext(store);
  const [dataList, setDataList] = useState([]);
  const [skip, setSkip] = useState(0)
  const [loading, setLoading] = useState(false);
  const dialogWidth = Dimensions.get('window').width / 3;
  const dialogHeight = Dimensions.get('window').height / 1.5
  const [searchText, setSearchText] = useState('');
  const debSearchText = useDebounce(searchText, 1000);

  useEffect(() => {
    loadDataList(0)
  }, [debSearchText])

  const loadDataList = async (pSkip) => {
    if (!loading) {
      setLoading(true);
      let res;
      let query = {
        ['$notInclude']: 1,
        shopThName: { $like: `%${searchText}%` },
        $skip: pSkip ?? skip, $sort: { id: 1 },
        $limit: 20
      }

      try {
        res = await globalState.client.service('shops').find({ query });
      } catch { }
      if (res) {
        if ((pSkip ?? skip) === 0) {
          setDataList(res.data);
        } else {
          setDataList(prev => [...prev, ...res.data]);
        }
        setSkip((res.skip + res.limit));
      }
      setLoading(false);
    }
  }

  return (
    <View>
      <TextInput
        value={searchText}
        onChangeText={text => setSearchText(text)}
        style={{ borderWidth: 1, borderColor: 'lightgray', height: 40, width: dialogWidth - 40, paddingHorizontal: 10 }}
      />
      <FlatList
        keyExtractor={(item) => item.id.toString()}
        style={{ marginTop: 10, height: (dialogHeight) - 70 }}
        data={dataList}
        onEndReached={(xxx) => loadDataList()}
        onEndReachedThreshold={0.5}
        onRefresh={() => loadDataList(0)}
        refreshing={(loading && skip == 0)}
        renderItem={({ item }) => <AddShopItem item={item} />}
      />
    </View>
  )
}

function AddShopItem({ item }) {
  return (
    <Pressable style={{ marginVertical: 10 }} onPress={() => {
      EventEmitter.notify('ShopCom::add', {
        id: Date.now(), shopId: item.id, shop: { id: item.id, shopPhoto1: item.shopPhoto1, shopThName: item.shopThName }
      })
    }}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Text style={{ marginLeft: 20 }}>{item.shopThName}</Text>
      </View>
    </Pressable>
  )
}



